import { Component, ReactNode, useEffect, useMemo, useRef, useState } from 'react'
import { CardPreview } from '../main-qr/components/card-preview'
import { CatalogDesign } from './data'
import { ModelPreview } from './model-preview'

class PreviewBoundary extends Component<{children: ReactNode; fallback: ReactNode}, {failed: boolean}> {
    state = {failed: false}
    static getDerivedStateFromError() { return {failed: true} }
    render() { return this.state.failed ? this.props.fallback : this.props.children }
}

export const Catalog3D = ({design, colorIndex = 0, paused = false, designs, designIndex = 0}: {design: CatalogDesign; colorIndex?: number; paused?: boolean; designs?: CatalogDesign[]; designIndex?: number}) => {
    const root = useRef<HTMLDivElement>(null)
    const [visible, setVisible] = useState(false)
    const [mounted, setMounted] = useState(false)
    const [reduced, setReduced] = useState(false)
    const images = useMemo(() => designs ? designs.map(item => item.colors?.[0]?.image ?? item.image) : design.colors?.map(color => color.image) ?? [design.image], [designs, design])
    const colors = useMemo(() => designs ? designs.map(item => item.colors?.[0]?.swatch ?? '#161616') : design.colors?.map(color => color.swatch) ?? ['#161616'], [designs, design])
    const activeIndex = designs ? designIndex : colorIndex
    useEffect(() => {
        const preference = window.matchMedia('(prefers-reduced-motion: reduce)')
        const update = () => setReduced(preference.matches)
        update()
        preference.addEventListener('change', update)
        const observer = new IntersectionObserver(([entry]) => {
            setVisible(entry.isIntersecting)
            if (entry.isIntersecting) setMounted(true)
        }, {threshold: 0.05})
        if (root.current) observer.observe(root.current)
        return () => { observer.disconnect(); preference.removeEventListener('change', update) }
    }, [])
    const fallback = <img className="catalog-3d-fallback" src={images[activeIndex]} alt={design.title} />
    return <div className="catalog-3d" ref={root} aria-label={`Объёмное превью: ${design.title}`}>
        {mounted && !reduced ? <PreviewBoundary key={design.modelUrl ?? 'card'} fallback={fallback}>
            {design.modelUrl
                ? <ModelPreview url={design.modelUrl} active={visible && !paused} />
                : <CardPreview key={designs ? 'collection' : design.id} images={images} backColors={colors} activeIndex={activeIndex} active={visible && !paused} />}
        </PreviewBoundary> : fallback}
        <span className="catalog-3d-hint">{reduced ? 'Превью дизайна' : '↔ Потяните, чтобы повернуть'}</span>
    </div>
}
